import { useState } from 'react';
import { Panel, SectorMapPanel, Tabs, ViewHeader } from '@spacegame/ui';
import type { RingId } from '@spacegame/ui';
import { useGame } from '../game/GameProvider';
import { GalaxyView } from './GalaxyView';

type Tab = 'rings' | 'system';

/**
 * Sektor-Karte — two tabs rather than a separate nav entry for the galaxy
 * plan's system view (packages/ui's SystemGrid): the mobile dock is already
 * full (see NavMenu's overflow handling), and "where's my system" is a
 * natural drill-down from "which ring am I in", not a distinct destination.
 */
export function SectorView({ galaxyTarget }: { galaxyTarget?: { ring: 1 | 2 | 3 | 4 | 5; system: number; position: number } | null }) {
  const { game } = useGame();
  const [tab, setTab] = useState<Tab>(galaxyTarget ? 'system' : 'rings');
  const [selected, setSelected] = useState<RingId | null>(game.planets[0]!.ring);

  const angle = (game.planets[0]!.system * 47 + game.planets[0]!.position * 13) % 360;

  return (
    <>
      <ViewHeader
        eyebrow="Galaktisches Ring-System"
        title="Sektor-Karte"
        description="Fünf konzentrische Zonen. Ring 5 schützt Neulinge, Ring 1 ist die Endgame-Zone ohne Anfängerschutz."
        actions={
          <Tabs
            variant="enclosed"
            value={tab}
            onChange={(id) => setTab(id as Tab)}
            items={[
              { id: 'rings', label: 'Ring-Übersicht' },
              { id: 'system', label: 'Mein System' },
            ]}
          />
        }
      />
      {tab === 'rings' ? (
        <Panel flush corners>
          <div className="p-4">
            <SectorMapPanel
              playerRing={game.planets[0]!.ring}
              selectedRing={selected}
              onSelectRing={setSelected}
              markers={[
                {
                  id: 'self',
                  ring: game.planets[0]!.ring,
                  angle,
                  kind: 'self',
                  label: `${game.planets[0]!.name} [${game.planets[0]!.ring}:${game.planets[0]!.system}:${game.planets[0]!.position}]`,
                },
                { id: 'core', ring: 1, angle: 150, kind: 'objective', label: 'Neutronenstern — Aether-Quelle (Endgame)' },
              ]}
            />
          </div>
        </Panel>
      ) : (
        <Panel corners>
          <GalaxyView target={galaxyTarget} />
        </Panel>
      )}
    </>
  );
}
